import { useYearContext } from "../../hooks/useYearContext";
import { useEffect, useState } from "react";
import Logo from "../../components/Logo";
import { Game } from "../../types";

export default function Live() {
    const { current } = useYearContext();
    const [, setGames] = useState<Game[]>([]);
    const [, setLive] = useState<boolean>(true);
    const [time, setTime] = useState<number>(0);

    const getTime = async () => {
        const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/changes`);
        const json: { time: string }[] = await response.json();
        if (response.ok) {
            if (time < new Date(json[0].time).valueOf()) {
                getGames();
                setTime(new Date(json[0].time).valueOf());
                console.log("A");
            } else {
                console.log("B");
            }
        } else {
            alert((json as any).error);
        }
    };

    const getGames = async () => {
        if (!current) return;

        const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/live?year=${current.year}`);
        const json: any[] = await response.json();
        if (response.ok) {
            setLive(json.length !== 0);

            const response2 = await fetch(`${process.env.REACT_APP_PATH}/api/game/upcoming?year=${current.year}`);
            const json2: any[] = await response2.json();
            if (response2.ok) {
                setGames([...json, ...json2]);
            } else {
                alert((json2 as any).error);
            }
        } else {
            alert((json as any).error);
        }
    };

    useEffect(() => {
        if (current && time === 0) {
            getTime();
        }
        const interval = setInterval(() => {
            if (current) {
                getTime();
                getGames();
            }
        }, 15000);

        return () => {
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current, time]);

    const [, setTimeX] = useState<number>(0);
    const [isRunning, setIsRunning] = useState<boolean>(false);

    // Timer effect
    useEffect(() => {
        let interval: NodeJS.Timeout | undefined;
        if (isRunning) {
            interval = setInterval(() => {
                setTimeX(prev => prev + 1);
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isRunning]);

    // Keyboard controls
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.code === 'Space') {
                e.preventDefault();
                setIsRunning(prev => !prev);
            } else if (e.code === 'ArrowUp') {
                e.preventDefault();
                setTimeX(prev => prev + 1);
            } else if (e.code === 'ArrowDown') {
                e.preventDefault();
                setTimeX(prev => Math.max(0, prev - 1));
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    // Format time as MM:SS
    // const formatTime = (seconds: number) => {
    //     const mins = Math.floor(seconds / 60);
    //     const secs = seconds % 60;
    //     return `${mins}:${secs.toString().padStart(2, '0')}`;
    // };

    return (
        <div className="bg-[rgb(0,255,0)] w-screen h-screen">
            {current !== undefined && <div className="absolute bg-black left-10 top-10"></div>}
            <Logo className="hover:text-accent-alt duration-300 scale-150 absolute right-12 top-12 text-black" />
        </div>
    );
}
